/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { GenericSuccessResponse } from '../models/generic-success-response';

/**
 * Session helpers for the in-memory Identity user/privilege cache on Clinical. Use invalidate after privilege changes (or optionally on logout) so the next request reloads the user profile from Identity.
 */
@Injectable({ providedIn: 'root' })
export class ClinicalSessionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `invalidateClinicalSession()` */
  static readonly InvalidateClinicalSessionPath =
    '/api/v1/clinical/session/invalidate';

  /**
   * Invalidate Clinical in-memory Identity user/privilege cache for the current session.
   *
   * Clears the short-lived in-memory cache of the caller's Identity user profile and privileges for this access token (and all cached sessions for the same user id). The next Clinical API request reloads the profile from Identity. Use after privilege changes when immediate refresh is needed. Optional on logout — Identity logout plus discarding the token is normally enough. Does not call Identity logout.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `invalidateClinicalSession()` instead.
   *
   * This method doesn't expect any request body.
   */
  invalidateClinicalSession$Response(
    params?: {},
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericSuccessResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      ClinicalSessionService.InvalidateClinicalSessionPath,
      'post'
    );
    if (params) {
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericSuccessResponse>;
        })
      );
  }

  /**
   * Invalidate Clinical in-memory Identity user/privilege cache for the current session.
   *
   * Clears the short-lived in-memory cache of the caller's Identity user profile and privileges for this access token (and all cached sessions for the same user id). The next Clinical API request reloads the profile from Identity. Use after privilege changes when immediate refresh is needed. Optional on logout — Identity logout plus discarding the token is normally enough. Does not call Identity logout.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `invalidateClinicalSession$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  invalidateClinicalSession(
    params?: {},
    context?: HttpContext
  ): Observable<GenericSuccessResponse> {
    return this.invalidateClinicalSession$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<GenericSuccessResponse>
        ): GenericSuccessResponse => r.body
      )
    );
  }
}
